export default __webpack_public_path__ + "static/bikebike-screen-acb7bbf739fd61254d43231d8b2005d0.png";